import { render, staticRenderFns } from "./govScheduleDetail.vue?vue&type=template&id=50b943bf"
import script from "./govScheduleDetail.vue?vue&type=script&lang=js"
export * from "./govScheduleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b943bf')) {
      api.createRecord('50b943bf', component.options)
    } else {
      api.reload('50b943bf', component.options)
    }
    module.hot.accept("./govScheduleDetail.vue?vue&type=template&id=50b943bf", function () {
      api.rerender('50b943bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gov/govScheduleDetail.vue"
export default component.exports